import { Route } from "@angular/router";
import { LectureComponent } from "./lecture.component";

export const LectureRouting: Route = {
    path: 'lecture',
    component: LectureComponent
};
